import { hash } from '@ember/helper';

import Font from '../font';

<template>
  <@form.fieldset
    @titleKey='header'
    @isClosed={{true}}
    @showSelectedAttributesIndicator={{true}}
    as |fieldset|
  >
    <fieldset.field @property='options.headerHide' @type='checkbox' />
    <fieldset.field @property='options.headerArtistLogoHide' @type='checkbox' />

    {{#unless @form.model.options.headerArtistLogoHide}}
      <fieldset.field
        @filters={{hash assetFolderId='8'}}
        @property='headerArtistCustomLogo'
        @options={{hash allowedFolder='8'}}
        @type='belongs-to'
      />
    {{/unless}}
    <fieldset.field @property='options.headerHideSocials' @type='checkbox' />
    <fieldset.field @property='options.headerFixed' @type='checkbox' />

    <Font
      @fieldset={{fieldset}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
      @prefix='headerFont'
    />

    <fieldset.field @property='options.headerMenuColor' @type='color' />
    <fieldset.field @property='options.headerMenuColorActive' @type='color' />

    <fieldset.field
      @property='options.headerBg'
      @type='color'
      @colorFormat='rgba'
    />
  </@form.fieldset>
</template>
